<div style="height:52vh;     
display: flex;
flex-direction: column;
justify-content: space-evenly; background-color: #2A4152;">
    <section class="section section--primary">
        <div class="shell shell--size-4">
            <div class="row" style="align-items: center;">
                <div class="col">
                    <div class="row mr-3">
                        <div class="col">
                            <a style="text-decoration: none;" (click)="open(content)">
                                <div>
                                    <div style="text-align: center">
                                        <img src="../../assets/img/IBKR-Mobile.png" style="max-width: 75%">
                                    </div>
                                </div>
                            </a>

                        </div>
                    </div>
                </div>
                <div class="col">
                    <div class="row ml-3">
                        <div class="col">
                            <a href="https://backseat-trader.com/login" style="text-decoration: none;">
                                <div>
                                    <div style="text-align: center; margin-top:20%; margin-bottom:20%">
                                        <img src="../../assets/img/Etoro_logo.svg.png" style="max-width: 75%;"/>
                                    </div>
                                </div>
                            </a>

                        </div>
                    </div>
                </div>
            </div>
        </div>
    </section>
</div>

<ng-template #content let-modal>
    <div class="modal-header">
        <h2 class="modal-title" id="exampleModalLabel">Now leaving Cosmic Algorithm</h2>
        <button type="button" class="btn-close" aria-label="Close" (click)="modal.dismiss('Cross click')"></button>
    </div>
    <div class="modal-body" style="text-align: center; font-size: large;">
        <div class="row">
            <div class="col">
                You are now leaving Cosmic Algorithm and navigating to the Interactive Brokers platform.<br />
            </div>
        </div>
        <br />
        <div class="row">
            <div class="col">
                Click below to visit our website detailing our presence on Interactive Brokers.<br /><br />

                <a class="btn btn-primary"
                    style="display:inline; font-size:large; background-color: #5ECE42; color: white; border:#5ECE42"
                    href="https://cosmic-algorithm.ie/">Click Here</a><br /><br />
            </div>
        </div>
    </div>
    <div class="modal-footer" style="justify-content: center; font-size: large; display:grid">
        <div class="row">
            <div class="col">
                <div class="spinner-border" role="status">
                    <span class="sr-only">Loading...</span>
                </div>
            </div>
        </div>
        <div class="row">
            <div class="col">
                {{seconds}}
            </div>
        </div>
    </div>
</ng-template>